import { moment, React, ts, ui } from '_core';

type DateRangeFieldProps = {
  value?: ts.types.dataSource.DATE_VALUE_TYPE;
  setValue: (_d: ts.types.dataSource.DATE_VALUE_TYPE) => void;
  label: string;
  minDate: string;
  maxDate: string;
};

const DateRangeField = ({ value, setValue, label, minDate = null, maxDate = null }: DateRangeFieldProps) => {
  const today = moment().format('YYYY-MM-DD');
  const oneMonthAgo = moment().subtract(1, 'months').format('YYYY-MM-DD');

  React.useEffect(() => {
    if (!value?.start && !value?.end)
      setValue({
        start: oneMonthAgo,
        end: today,
      });
  }, []);

  return (
    <ui.FinDateRangePicker
      label={label}
      maxDate={maxDate}
      minDate={minDate}
      value={[value?.start ?? oneMonthAgo, value?.end ?? today]}
      onChange={(v) => setValue({ start: v?.[0], end: v?.[1] })}
    />
  );
};

export default DateRangeField;
